import {CardBox} from '@hconnect/uikit/src/lib2'
import {Stack} from '@mui/material'
import {useFormContext} from 'react-hook-form'

import {ChecklistStepSection, YesNoWithCommentField} from '../../components'
import {HROC_CHECKLIST_FORM_WIDTH_IN_PX} from '../../consts'
import {useWidgetTranslation} from '../../hooks'
import type {KilnCheckSheetCoolerBaghouseSectionFormValues} from '../../types'
import {StepFormActionsContainer} from '../StepFormActionsContainer'

type Props = {
  readOnly?: boolean
}

export const CoolerBaghouseSectionFields = ({readOnly = false}: Props) => {
  const {control} = useFormContext<KilnCheckSheetCoolerBaghouseSectionFormValues>()
  const {t} = useWidgetTranslation()

  return (
    <CardBox width={{xs: '100%', md: HROC_CHECKLIST_FORM_WIDTH_IN_PX}}>
      <Stack spacing={2}>
        <ChecklistStepSection title={t('kilnCheckSheet.label.baghouseFan5930')}>
          <YesNoWithCommentField
            label={t('kilnCheckSheet.label.baghouseFan5930DamageLeaks')}
            name="baghouseFan5930DamageLeaks"
            control={control}
            readOnly={readOnly}
          />
        </ChecklistStepSection>
        <ChecklistStepSection title={t('kilnCheckSheet.label.screwsDragsElevator')}>
          <YesNoWithCommentField
            label={t('kilnCheckSheet.label.screwsDragsElevatorDamageLeaks')}
            name="screwsDragsElevatorDamageLeaks"
            control={control}
            readOnly={readOnly}
          />
        </ChecklistStepSection>
        <StepFormActionsContainer />
      </Stack>
    </CardBox>
  )
}
